/*  越南语包  */
import viLocale from 'element-ui/lib/locale/lang/vi';
const yny = {
    message: {
        /*  导航栏语言设定 */
        'headerMenu' : 'Đĩa mây',
        'headerlangSelect' : 'Vui lòng chọn một ngôn ngữ',
        'headerLoginOut' : 'Đăng xuất',

        /*  侧边栏语言设定 */
        'sideMenuFileName' : 'Tất cả các tập tin',
        'sideMenuPhoto' : 'Hình ảnh',
        'sideMunsDoc' : 'Tài liệu',
        'sideMenuVideo' : 'video',
        'sideMenuSeed' : 'Hạt giống',
        'sideMenuMusic' : 'Âm nhạc',
        'sideMenuOrther' : 'Khác',
        'sideMenuShareName' : 'Chia sẻ của tôi',
        'sideMenuCollectName' : 'Thùng rác',

        /*  用户语言设定 */
        'mainUpload' : 'Tải lên',
        'mainBuildDir' : 'Thư mục mới',
        'mainDownloadOutline' : 'Tải xuống ngoại tuyến',
        'mainSearch' : 'Tìm kiếm tập tin',
        'mainAllFile' : 'Tất cả các tập tin',
        'mainFile' : 'Tập tin',
        'mainSize' : 'Kích thước',
        'mainDate' : 'Ngày',
        'mainFileDel' : 'Xóa',
        'mainConfirmDel' : 'Xác nhận xóa?',
        'sure' : 'Xác nhận',
        'cancel' : 'Hủy bỏ',
        'mainReturn' : 'Quay lại',
        'mainPagePrev' : 'Trước đó',
        'mainPageNext' : 'Trang tiếp theo',
        'mainLoaded' : 'Đã tải',
        'mainTotal' : 'Tổng cộng',
        'mainUnit' : 'Dải',
        'dilatation' : 'Mở rộng',
        /*  回收站设定  */
        'mainHeaderTitle' : 'Mẹo: Thùng rác không chiếm dung lượng đĩa mạng.',
        'mainHeaderButton' : 'Thùng rác',
        'collectName' : 'Thùng rác',
        'mainRevertIts' : 'Khôi phục',
        'mianDelData' : 'Xóa thời gian',

        'confirmClear' : 'Xác nhận để xóa các tập tin được chọn? (Không thể phục hồi sau khi xóa)',
        'confirmClearAll' : 'Bạn có chắc chắn muốn đổ thùng rác?',

        /*  其他设定 */
        'messageBoxTitle' : 'Gợi ý',
        'messageBoxConfirmRevert' : 'Xác nhận để khôi phục tập tin đã chọn?',
        'loading' : 'Đang tải ...',
        'loaded' : 'Không có dữ liệu',

        'messageMoveTo' : 'Di chuyển đến',
        'filterNotice' : 'Nhập từ khóa để lọc',
        'messageLoaded' : 'Đã tải xuống:',
        'messageMovetion' : 'Di chuyển tập tin',

        'messageMissKeyWord' : 'Vui lòng nhập từ khóa tìm kiếm',
        'messageFolderLayersLimit' : 'Tạo thất bại Độ sâu phân cấp thư mục không vượt quá 5 cấp',
        'messageSameFolderName' : 'Tạo thất bại Tên tệp tương tự tồn tại',
        'messageEmptyFolderName' : 'Vui lòng nhập tên thư mục',
        'messageMoveSame' : 'Không thể di chuyển đến cùng một thư mục',
        'messageActionError' : 'Hoạt động thất bại',
        'messageActionSuccess' : 'Hoạt động thành công',
        'messageServerIsBusy' : 'Máy chủ đang bận',
        'messageUploadOverLimit' : 'Quá nhiều tệp được chọn (trong vòng 5)',
        'messageDiskFreeFull' : 'Không gian người dùng không đủ',
        'messageUploadTypeError' : 'Không thể tải lên loại tệp này',
        'messageUploadMaxSize' : 'Tệp tải lên quá lớn (trong vòng 10 triệu)',
        'messageUploadSuccess' : 'Đã tải lên thành công',
        'messageUploadFailed' : 'Tải lên thất bại',
        'messageDownloadFailed' : 'Tải xuống thất bại'
    },
    ...viLocale
};

export default yny;



// WEBPACK FOOTER //
// ./src/i18n/langs/yny.js